/**
 * Input type selection cards for Step 1
 */

import { motion } from "framer-motion";
import { Check, Link2, FileText, Image, Video, Sparkles } from "lucide-react";
import { inputOptions } from "./constants";

const gradients = [
  "from-blue-500/20 to-cyan-500/20 hover:from-blue-500/30 hover:to-cyan-500/30",
  "from-purple-500/20 to-pink-500/20 hover:from-purple-500/30 hover:to-pink-500/30",
  "from-orange-500/20 to-yellow-500/20 hover:from-orange-500/30 hover:to-yellow-500/30",
  "from-green-500/20 to-emerald-500/20 hover:from-green-500/30 hover:to-emerald-500/30"
];

const iconMap = {
  url: Link2,
  text: FileText,
  image: Image,
  video: Video
};

export function InputTypeSelector({ inputType, onSelect }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {inputOptions.map((opt, i) => {
        const Icon = iconMap[opt.id];
        return (
          <motion.button
            key={opt.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            onClick={() => onSelect(opt.id)}
            data-testid={`input-option-${opt.id}`}
            className={`relative p-4 rounded-xl bg-gradient-to-br ${gradients[i]} border-2 transition-all text-left ${
              inputType === opt.id
                ? "border-viraly-orange shadow-lg shadow-viraly-orange/20"
                : "border-transparent hover:border-white/20"
            }`}
          >
            <div className="flex items-start justify-between mb-2">
              <Icon className={`w-6 h-6 ${inputType === opt.id ? "text-viraly-orange" : "text-white/70"}`} />
              {opt.subtitle && (
                <span className="px-1.5 py-0.5 text-[10px] font-bold bg-viraly-orange/20 text-viraly-orange rounded flex items-center gap-1">
                  <Sparkles className="w-2.5 h-2.5" />
                  {opt.subtitle}
                </span>
              )}
            </div>
            <h3 className="font-semibold text-sm">{opt.title}</h3>
            <p className="text-xs text-viraly-muted mt-1 line-clamp-1">{opt.desc}</p>
            
            {/* Show supported platforms for URL option */}
            {opt.supportedPlatforms && inputType === opt.id && (
              <p className="text-[10px] text-viraly-muted/70 mt-2 line-clamp-2">{opt.supportedPlatforms}</p>
            )}
            
            {inputType === opt.id && (
              <div className="absolute top-2 right-2">
                <div className="w-5 h-5 rounded-full bg-viraly-orange flex items-center justify-center">
                  <Check className="w-3 h-3 text-white" />
                </div>
              </div>
            )}
          </motion.button>
        );
      })}
    </div>
  );
}
